function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Converter from "./converter";

var Guard = /*#__PURE__*/function () {
  function Guard() {
    _classCallCheck(this, Guard);

    /** @readonly {ValidationSet[]} */
    this.validations = [];
  }

  _createClass(Guard, [{
    key: "create",
    value: function create(key, alias) {
      var as = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var validationSet = new ValidationSet(key, alias, as);
      this.validations.push(validationSet);
      return validationSet;
    }
  }, {
    key: "test",
    value: function test(subject) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var valid = true;
        var result = [];
        var validations = [];

        _this.validations.forEach(function (validationSet) {
          return validations.push(validationSet.validate(subject));
        });

        Promise.all(validations).then(function (results) {
          results.forEach(function (validationSet) {
            if (!validationSet.isValid) {
              result = result.concat(validationSet.result);
              valid = false;
            }
          });
          valid ? resolve(subject) : reject(result);
        });
      });
    }
  }]);

  return Guard;
}();

export { Guard as default };

var ValidationSet = /*#__PURE__*/function () {
  function ValidationSet(key, alias) {
    var as = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, ValidationSet);

    /** @readonly {string} */
    this.key = key;
    /** @readonly {string} */

    this.as = as === null ? key : as;
    /** @readonly {string} */

    this.alias = alias === null ? key : alias;
    /** @protected {Array} */

    this.validators = [];
    /** @protected {any} */

    this._default = undefined;
    /** @protected {boolean} */

    this._allowEmpty = false;
    /** @protected {boolean} */

    this._valid = true;
    /** @protected */

    this.result = [];
  }

  _createClass(ValidationSet, [{
    key: "default",
    value: function _default() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this._default = value;
      return this;
    }
  }, {
    key: "allowEmpty",
    value: function allowEmpty() {
      this._allowEmpty = true;
      return this;
    }
  }, {
    key: "isValid",
    get: function get() {
      return this._valid;
    }
  }, {
    key: "add",
    value: function add(validator) {
      this.validators.push(validator);
      return this;
    }
  }, {
    key: "validate",
    value: function validate(subject) {
      var _this2 = this;

      this.result = [];
      var key = this.key;
      if (typeof subject[key] === "undefined" && this._allowEmpty) return;
      if (typeof subject[key] === "undefined" && typeof this._default !== "undefined") subject[key] = this._default;
      var tasks = [];

      for (var i in this.validators) {
        var validator = this.validators[i];

        if (validator instanceof Converter) {
          validator.convert(subject, key);
        } else {
          tasks.push(new Validation(this, validator, subject).validate());
        }
      }

      return Promise.all(tasks).then(function (validations) {
        for (var _i in validations) {
          var validation = validations[_i];

          if (validation.result instanceof Error) {
            _this2.result.push(validation.result);

            _this2._valid = false;
            if (!validation.continueOnError) break;
          }
        }

        return _this2;
      });
    }
  }]);

  return ValidationSet;
}();

var Validation = /*#__PURE__*/function () {
  function Validation(validationSet, validator, subject) {
    _classCallCheck(this, Validation);

    /** @readonly {ValidationSet} */
    this.validationSet = validationSet;
    /** @readonly {Validator} */

    this.validator = validator;
    /** @readonly {subject} */

    this.subject = subject;
    /** @readonly {boolean|Error} */

    this.result = true;
  }

  _createClass(Validation, [{
    key: "key",
    get: function get() {
      return this.validationSet.key;
    }
  }, {
    key: "alias",
    get: function get() {
      return this.validationSet.alias;
    }
  }, {
    key: "value",
    get: function get() {
      return this.subject[this.key];
    }
  }, {
    key: "args",
    get: function get() {
      return this.validator.args;
    }
  }, {
    key: "id",
    get: function get() {
      return this.validator.id;
    }
  }, {
    key: "continueOnError",
    get: function get() {
      return this.validator.continueOnError;
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this3 = this;

      var result = this.validator.validate(this);
      if (!(result instanceof Promise)) return Promise.resolve(this);
      return result.then(function () {
        return _this3;
      });
    }
  }, {
    key: "resultOk",
    value: function resultOk() {
      this.result = true;
      return this;
    }
  }, {
    key: "resultError",
    value: function resultError() {
      var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.result = new Error(this, code);
      return this;
    }
  }]);

  return Validation;
}();

var Error = /*#__PURE__*/function () {
  /**
   *
   * @param {Validation} validation
   * @param code
   */
  function Error(validation, code) {
    _classCallCheck(this, Error);

    this.code = code;
    this.validation = validation;
    this.as = validation.validationSet.as;
  }

  _createClass(Error, [{
    key: "message",
    get: function get() {
      return typeof this.validation.validator.message === "function" ? this.validation.validator.message(this, this.validation) : this.validation.validator.message;
    }
  }, {
    key: "toString",
    value: function toString() {
      return typeof this.validation.validator.message === "function" ? this.validation.validator.message(this, this.validation) : this.validation.validator.message;
    }
  }]);

  return Error;
}();